module.exports = __webpack_public_path__ + "static/media/whats.3a8dad7f.png";